"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const YearlyMonthlyValue_1 = tslib_1.__importDefault(require("./YearlyMonthlyValue"));
class GetTariffsTotalAmounts extends YearlyMonthlyValue_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 250, description: 'Proposed monthly installment including the price ceiling.' }),
    tslib_1.__metadata("design:type", Number)
], GetTariffsTotalAmounts.prototype, "proposedMonthlyInstallment", void 0);
exports.default = GetTariffsTotalAmounts;
